let VConfirm = {
  data: () => ({
    value: false,
    successCb: null,
    failureCb: null,
    title: '',
    message: ''
  }),

  methods: {
    handleSuccess () {
      this.value = false
      this.successCb()
    },
    handleFailure () {
      this.value = false
      this.failureCb()
    }
  },

  render (h) {
    return h('v-dialog', {
      on: { input: ev => this.value = ev },
      props: Object.assign({
        persistent: true,
        maxWidth: 300
      }, this.$data)
    }, [
      h('v-card', [
        h('v-card-title', { 'class': { headline: true } }, this.title),
        h('v-card-text', this.message),
        h('v-divider'),
        h('v-card-actions', [
          h('v-spacer'),
          h('v-btn', {
            on: { click: this.handleFailure },
            props: { flat: true }
          }, [ 'Cancel' ]),
          h('v-btn', {
            on: { click: this.handleSuccess },
            props: { flat: true }
          }, [ 'Ok' ])
        ])
      ])
    ])
  }
}

export default {
  install: function (Vue, opt) {
    let VConfirmConstructor = Vue.extend(VConfirm)

    Vue.prototype.$confirm = function (options) {
      let container = document.getElementById('v-app-plugin-container')

      return new Promise(function (successCb, failureCb) {

        let instance = new VConfirmConstructor({
          data: Object.assign({
            successCb,
            failureCb
          }, options)
        })

        instance.$mount()
        container.appendChild(instance.$el)
        instance.value = true
      })
    }
  }
}
